import React from "react";
import { IconProps } from "../icon";

export const ArrowNarrowUpLeftIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke={color} strokeLinecap="square" strokeWidth="2" d="M18 18L6 6m0 0v8m0-8h8" />
  </svg>
);
